import { authHeader, handleResponse } from "../helper/auth-header";

export default class DispatchService {
  ControllerName = "QRJourney";

  // async GetJourney(d) {
  //   const requestOptions = {
  //     method: "GET",
  //     headers: authHeader()
  //   };

  //   const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetQRJourney?qr=${d}`;
  //   const response = await fetch(url, requestOptions);
  //   const data = await handleResponse(response, { url, ...requestOptions });
  //   return data;
  // }

  async GetJourney(d, brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader(),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetQRJourney?qr=${d}&brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetScanInfo(d) {
    const requestOptions = {
      method: "GET",
      headers: authHeader(),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetScanInfo?qr=${d}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetDispatchToPrint(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchToPrint`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
